module.exports = __webpack_public_path__ + "img/SZ.6e224dc9.svg";